///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.replenishment_request = abcsetup.replenishment_request || {};
abcsetup.replenishment_request.workflow = abcsetup.replenishment_request.workflow || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.replenishment_request.workflow = {

    workflow_task: null,

    /**
     *
     */
    init: function () {
        $('[data-toggle="tooltip"]').tooltip();

        abcsetup.setTitle('Replenishment Operations');
        abcsetup.replenishment_request.common.bindFormElems();

        $(function() {
            $( "#sortable" ).sortable({
                placeholder: "ui-state-highlight"
            });
        });

        // Reject button clicked
        $('#reject-btn, .reject-btn.required').on('click', function () {
            return abcsetup.replenishment_request.workflow._rejectItem($(this));
        });

        // Assign the local workflow_task var
        this.workflow_task = JSON.parse($('#WorkflowTask').val());

        // RO Team is selecting supplier submitted items
        $('.ro-team-select').on('click', function (e) {
            if ($(this).is(':checked')) {
                $(this).closest('tr').addClass('table-success');
            } else {
                $(this).closest('tr').removeClass('table-success');
            }
        });

        // Lookup ABC Item info and add supply issue item
        $('#assign-ro').on('click', function(event) {
            var role_id = $(this).data('role-id');
            var request_id = $(this).data('request-id');

            abcsetup.alerts.confirm('Assign Request', 'Are you sure you want to assign this request to yourself? You will be responsible for moving this request forward.', function (resp) {
                if (resp) {
                    abcsetup.replenishment_request.workflow._assignRORole(role_id, request_id);
                }
            });
        });

        // Toggle visibility of alternate item review table
        $('#no_items_check').on('click', function(event) {
            $('#alternate-item-review-table').toggle();
            $('#alternate-item-add').toggle();
            $('#ma-or-nad').toggle();

            if ($('#no_items_check').is(':checked') && abcsetup.replenishment_request.workflow.workflow_task.role_class == "cpoc_user") {
                $("#app_models_replenishment_request_alternate_items_alternate_items_grant_nad").attr("required", true);
            } else {
                $("#app_models_replenishment_request_alternate_items_alternate_items_grant_nad").attr("required", false);
            }

            if (abcsetup.replenishment_request.workflow.workflow_task.role_class == "cpoc_user") {
                $('#cpoc_nad_fields').toggle();
            }
        });

        // Change form action on submit for ESI user final workflow task
        $('#app_models_replenishment_request_esi_esi_able_to_order').on('change', function(event) {
            if ($(this).val() == 1) {
                $('#approve-delay').val('approve');
            } else {
                $('#approve-delay').val('delay');
            }
        });

        // On ESI user selecting single item to move forward with, enable/disable dha_approved and nad_ndc fields
        $('input[name="item_ids[]"]').on('change', function(event) {
            $('.esi-fields').val('').prop('disabled', true);
            $(this).closest('tr').find('.esi-fields').prop('disabled', false);
        });

        // On ESI user selecting single item to move forward with, disable field requirements
        $('#no_items_check').on('change', function(event) {
            if (abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_esi_review') {
                $('input[name="item_ids[]"]').prop('checked', false);
                $('input[name="item_ids[]"], .esi-fields').prop('required', !$(this).prop('checked'));
            }
        });

        $('#app_models_replenishment_request_dla_support_dla_support_dla_support').on('change', function(event) {
            if (!$('.dla-alert').length && $(this).val() == 1) {
                $('input[name="item_ids[]"]').prop('checked', false).prop('disabled', true);
                $('#alternate-item-review-table tr').removeClass('table-success');
            } else {
                $('input[name="item_ids[]"]').prop('disabled', false);
            }
        });

        // Make sure the supplier hours field is required if an alternate item is selected
        $('input[name="item_ids[]"]').on('change', function(event) {
            if (abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_ro_team_review' && $('input[name="item_ids[]"]').is(':checked')) {
                $('#app_models_replenishment_request_ro_team_ro_team_supplier_hours').prop('required', true);
            } else (
                $('#app_models_replenishment_request_ro_team_ro_team_supplier_hours').val('').prop('required', false)
            )
        });

        // Get supplier deadline date
        $('#app_models_replenishment_request_ro_team_ro_team_supplier_hours').on('change', function(event) {
            abcsetup.replenishment_request.workflow._getSupplierDeadlineDate($(this).val());
        });

        // Clear out values for supplier depending on their can supply answer
        $('.can-supply').on('change', function(event) {
            if ($(this).val() == '0') {
                $(this).closest('tr').find('.supplier-quantity, .supplier-comments, .supply-date, .taa-compliant, .country-of-origin').val('');
            }
        });

        // Clear out comments if supplier entered comments on a partial supply, but then changed to full
        $('.supplier-quantity').on('change', function(event) {
            if ($(this).val() == 'Full') {
                $(this).closest('tr').find('.supplier-comments').val('');
            }
        });

        // Validate if at least one alternate item has been added
        // $('form').on('submit', function(e) {
        $(document).on("click", ":submit", function(e) {
            // We dont want to run these checks on save or reject!
            if ($(this).val() == 'approve' || $(this).val() == 'submit') {
                if (abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_ro_team_review') {
                    var no_items = !$('#no_items_check').is(':checked') && !$('input[name="item_ids[]"]').is(':checked');
                    var no_assignment = $('#assign-ro').is(":visible");

                    if (no_items || no_assignment) {
                        e.preventDefault();
                        abcsetup.alerts.show('Submission Errors', 'You have the following submissions errors: <br>' +
                        '<ul>' +
                        (no_items ? '<li>You must select an alternate item to continue.</li>' : '') +
                        (no_assignment ? '<li>You must assign the task to yourself.</li>' : '') +
                        '</ul>');
                        return;
                    }
                }

                if (abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_ro_manager_eligibility_review') {
                    if ($('.dla-alert').length == 1
                        && $('#app_models_replenishment_request_dla_support_dla_support_dla_support').val() == 1
                        && !$('input[name="item_ids[]"]').is(':checked') ) {
                            e.preventDefault();
                            abcsetup.alerts.show('No Alternate Items Selected', 'You must select an alternate item to continue.');
                            return;
                    }

                    if ($('#app_models_replenishment_request_dla_support_dla_support_dla_support').val() == 0 && !$('input[name="item_ids[]"]').is(':checked')) {
                            e.preventDefault();
                            abcsetup.alerts.show('No Alternate Items Selected', 'You must select an alternate item to continue.');
                            return;
                    }
                }

                if ((abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_market_analysis_r1'
                    || abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_market_analysis_r2')
                    && $('#sortable li').length == 0) {
                        e.preventDefault();
                        abcsetup.alerts.show('No Alternate Items Selected', 'You must enter at least one alternate item to continue.');
                        return;
                }

            }

            // If account manager is rejecting on Market Analysis 2 task, make sure they upload a GSN item review file
            if ($(this).val() == 'reject'
                && abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_market_analysis_r2'
                && !$('#app_models_replenishment_request_gsn_item_review_gsn_item_review_gsn_attachment').val()) {
                    e.preventDefault();
                    abcsetup.alerts.show('GSN Item Review File', 'You must upload a GSN Item Review File to continue with NAD.');
                    return;
            }

            if (abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_esi_review'
                && !$('#new_sap_num').val()
                && !$('.esi-select').is(':checked')
                && !$('.modal').is(":visible")) {
                    e.preventDefault();
                    abcsetup.alerts.show('No Alternate Items Selected', 'You must enter at least one alternate item to continue.');
            }
        });

        $(window).on( "load", function() {
            // Disable inputs for ro team members on initial workflow task until they assign to themselves
            if ((abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_ro_team_review'
                || abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_market_analysis_r1' )
                && $('#assign-ro').is(":visible")) {
                $("input[type=checkbox], input[type=text], input[type=number], select").prop('disabled', true);
            }

            // Hide "Replace" and "Delete" buttons for CPOC Non-Availability task
            if (abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_cpoc_non_availability') {
                $("#wiz-gsn_item_review").find('.btn-warning, .btn-danger').hide();
            }

            // Default Market Analysis 2 task to GSN Item Review tab
            if (abcsetup.replenishment_request.workflow.workflow_task.task == 'replenishment_request_market_analysis_r2') {
                // Remove 'current' class from any of the existing tabs and add it to the GSN Item Review tab
                $('#item_tabs li').removeClass('current');
                $('a[href="#wiz-gsn_item_review"]').closest('li').addClass('current');

                // Hide all content panels and show the GSN Item Review content panel
                $('.item-form-body').find('.form-div').hide();
                $('#wiz-gsn_item_review').show();
            }
        });

        // Bind any fields events
        abcsetup.replenishment_request.common.bindFields();

        // Init non-yajra datatable
        abcsetup.datatables.client_side.init($('#alternate-item-review-table'), {
            'dom': 'x',
            'iDisplayLength': -1,
            'order': [[1, 'asc']],
            'responsive': false,
        });
    },

    /**
     * Reject the item
     */
    _rejectItem: function (btn) {

        // We don't have a reject reason
        if (!$(':checkbox[name^="reject_reason"]').length) {
            btn.unbind('click').attr('type', 'submit').trigger('click');
        }

        // We have multiple rejection reasons
        if ($(':checkbox[name^="reject_reason"]').length > 1) {
            if ($(':checkbox[name^="reject_reason"]:checked').length == 0) {
                abcsetup.alerts.show('Reject NPV Alternate Sourcing', 'Please specify a rejection reason.');
                return false;
            }

        } else {
            const rejectReasonField = $('textarea[name="reject_reason"].required');

            if (!rejectReasonField.val()) {
                rejectReasonField.addClass('error');
                return false;
            }
        }

        btn.unbind('click').attr('type', 'submit').trigger('click');
    },

    /**
     *  Assign RO Role to Replenishment Request
     *
     * @param {*} field
     */
    _assignRORole: function(role_id, request_id) {
        abcsetup.blockUI(true);

        axios.post('/api/replenishment_operations/assignRORole', { role_id: role_id, request_id: request_id }).then(response => {
            if (response.data == 'success') {
                $('#needs-assignee').hide();
                $('#assigned-to').show();
                $("input[type=checkbox], input[type=text], input[type=number], select").prop('disabled', false);
            } else {
                $('#needs-assignee').hide();
                $('#assigned-already').show();
            }
        });

        abcsetup.unblockUI();
    },

    /**
     *  Get Supplier Deadline date
     *
     * @param {*} field
     */
    _getSupplierDeadlineDate: function(hours) {
        abcsetup.blockUI(true);

        axios.post('/api/replenishment_operations/getSupplierDeadlineDate', { hours: hours }).then(response => {
            if (response.data) {
                abcsetup.alerts.show('Supplier Deadline', 'If sent to suppliers today, supplier deadline is ' + response.data);
            }
        });

        abcsetup.unblockUI();
    },
}
